import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const pelayanRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'pelayan',
  component: lazyRouteComponent(() => import('./layout'), 'PelayanLayout'),
});

const floorRoute = createRoute({
  getParentRoute: () => pelayanRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./floor-page'), 'PelayanFloorPage'),
});

const tableRoute = createRoute({
  getParentRoute: () => pelayanRoute,
  path: 'meja/$tableId',
  component: lazyRouteComponent(() => import('./table-page'), 'PelayanTablePage'),
});

const orderRoute = createRoute({
  getParentRoute: () => pelayanRoute,
  path: 'pesanan/$orderId',
  component: lazyRouteComponent(() => import('./order-page'), 'PelayanOrderPage'),
});

export const pelayanTree = pelayanRoute.addChildren([floorRoute, tableRoute, orderRoute]);
